import { Component, OnInit } from '@angular/core';
import { ContactService } from '../shared/contact.service';
import { Edit, LucideAngularModule, Plus } from 'lucide-angular';
import { PagedEntities } from '@app/shared/abstract/paged-entities';
import { RouteParams } from '@app/shared/abstract/route-params';
import { Column } from '@app/partials/datatable/data-table/column';
import { DataTableComponent } from '@app/partials/datatable/data-table/data-table.component';
import { RouterLink } from '@angular/router';
import { UserModel } from '@app/users/shared/user.model';

@Component({
  selector: 'app-index11',
  imports: [DataTableComponent, LucideAngularModule, RouterLink],
  templateUrl: './contacts-index.component.html',
})
export class ContactsIndexComponent implements OnInit {
  constructor(private service: ContactService) {}

  protected readonly PlusIcon = Plus;
  protected readonly EditIcon = Edit;

  protected usersPage?: PagedEntities<UserModel>;

  routeParams = new RouteParams({
    pageNum: 1,
  });

  tableColumns: Column<UserModel>[] = [
    { field: 'name', header: 'Name', sortable: true },
    { field: 'email', header: 'Email' },
    {
      field: 'phone_numbers',
      header: 'Phone Number(s)',
      callback: (item: UserModel) => item.phone_numbers?.join(', '),
    },
    {
      field: 'address',
      header: 'Address',
      callback: (item: UserModel) => {
        const addressParts = [item.address_line_1, item.address_line_2, item.city, item.postcode, item.country].filter(
          (part) => part,
        ); // This removes any null, undefined or empty strings
        return addressParts.join(', ');
      },
    },

    { field: 'created_at', header: 'Created At', sortable: true },
  ];

  rowActions = [{ icon: this.EditIcon, type: 'link', routerLink: (item: UserModel) => ['/contacts', item.id, 'edit'] }];

  loadData() {
    this.service.getPage(this.routeParams).subscribe((res) => {
      this.usersPage = res;
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  handleRoute(params: RouteParams) {
    this.routeParams.sort = params.sort;
    this.routeParams.pageNum = params.pageNum;
    this.routeParams.pageSize = params.pageSize;
    this.loadData();
  }
}
